import { render, staticRenderFns } from "./list_shuigan.vue?vue&type=template&id=08baf8cc&scoped=true"
import script from "./list_shuigan.vue?vue&type=script&lang=js"
export * from "./list_shuigan.vue?vue&type=script&lang=js"
import style0 from "./list_shuigan.vue?vue&type=style&index=0&id=08baf8cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08baf8cc",
  null
  
)

export default component.exports